module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "c-arrow-link",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "6",
      "height": "11",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac76423"}!./src/scripts/components/app-arrow-link/template.html
// module id = 937
// module chunks = 0